import { i18n } from '../i18n';
import en from '../i18n/locales/en.json';

const wizardFields = (en as { wizard: { fields: Record<string, string> } }).wizard.fields;

const WIZARD_FIELD_LABEL_TO_KEY: Record<string, string> = {};
for (const [key, label] of Object.entries(wizardFields)) {
  WIZARD_FIELD_LABEL_TO_KEY[label] = `wizard.fields.${key}`;
}

/** English validation labels that differ from wizard.fields or need explicit mapping. */
const EXTRA_VALIDATION_LABEL_KEYS: Record<string, string> = {
  'Accused / Suspect Name': 'wizard.fields.accusedSuspectName',
  'Accused / Suspect Status': 'wizard.fields.accusedSuspectStatus',
  'Status (Other)': 'wizard.fields.statusOther',
  Reason: 'wizard.fields.reason',
  'Petitioner Address': 'wizard.fields.petitionerAddress',
  'Next Step (Other)': 'wizard.fields.nextStepOther',
  'Other Next Step of the Case': 'wizard.fields.nextStepOther',
  'Preferred Language': 'wizard.fields.preferredLanguage',
  'Are there any connected matters (Advises/Cases)?': 'wizard.fields.connectedMattersAdvises',
};

export function translateValidationFieldLabel(label: string): string {
  const trimmed = label.trim();
  if (!trimmed) return label;
  const key = EXTRA_VALIDATION_LABEL_KEYS[trimmed] ?? WIZARD_FIELD_LABEL_TO_KEY[trimmed];
  return key ? i18n.t(key) : label;
}

export function requiredFieldError(label: string): string {
  return i18n.t('validation.fieldRequired', { field: translateValidationFieldLabel(label) });
}

export function validationMaxCharLimit(): string {
  return i18n.t('validation.maxCharLimit');
}

export function validationDateFutureOnly(): string {
  return i18n.t('validation.dateFutureOnly');
}

export function validationDocReasonRequired(): string {
  return i18n.t('validation.docReasonRequired');
}

export function validationDateOfOffenceFuture(): string {
  return i18n.t('validation.dateOfOffenceFuture');
}
